import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class AttendanceWifiApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'attendanceWifi'
    }

}